export const favoriteBrandsCacheName = 'state.favoriteBrands';
export const favoriteBrandsSessionName = 'favorite-brands.session';
export const FAVORITE_PRODUCTS_SESSION_CACHE_NAME = 'favorites.session';
export const FAVORITE_PRODUCTS_CACHE_NAME = 'state.favoriteProducts';
